import { Skeleton } from 'antd'
import Styles from './ImageSkeleton.module.scss'
import { SkeletonProps } from 'antd/lib/skeleton'

export const ImageSkeleton = (props: Pick<SkeletonProps, 'loading'>) => (
  <Skeleton active paragraph={false} className={Styles.skeleton} {...props} />
)
